import React from 'react'
import PropTypes from 'prop-types'

import { Form, Modal } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './CreateUserModalContainer'
import Enhancer from './CreateUserModalEnhancer'

import Button from 'Components/StandardButton'
import ErrorMessage from 'Components/ErrorMessage'

import icons from 'Global/icons'

import * as styles from './styles'

const CreateUserModal = props => {
  const {
    close,
    email,
    firstName,
    handleCreate,
    handleEmailChanged,
    handleFirstNameChanged,
    handleLastNameChanged,
    hasError,
    isPending,
    lastName,
  } = props

  return (
    <Modal onClose={close} open={true}>
      <Modal.Header>Create Group</Modal.Header>

      <Modal.Content>
        {hasError && <ErrorMessage message="This wasn't supposed to happen. Please try again. Duplicate group names are forbidden." />}

        <Form onSubmit={handleCreate} size="tiny">
          <Form.Field>
            <Form.Input
              label="First Name"
              name="firstName"
              onChange={handleFirstNameChanged}
              placeholder="First Name"
              style={styles.input}
              type="text"
              value={firstName}
              required
            />
          </Form.Field>

          <Form.Field>
            <Form.Input
              label="Last Name"
              name="lastName"
              onChange={handleLastNameChanged}
              placeholder="Last Name"
              style={styles.input}
              type="text"
              value={lastName}
              required
            />
          </Form.Field>

          <Form.Field>
            <Form.Input
              label="Email"
              name="email"
              onChange={handleEmailChanged}
              placeholder="Email"
              style={styles.input}
              type="email"
              value={email}
              required
            />
          </Form.Field>

          <div style={styles.button}>
            <Button color="black" content="Create" disabled={isPending} error={hasError} icon={icons['create']} pending={isPending} />
          </div>
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button content="Close" icon={icons['close']} onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

CreateUserModal.propTypes = {
  close: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  handleCreate: PropTypes.func.isRequired,
  handleEmailChanged: PropTypes.func.isRequired,
  handleFirstNameChanged: PropTypes.func.isRequired,
  handleLastNameChanged: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  lastName: PropTypes.string.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(CreateUserModal)
